<div class="flex max-h-full min-h-0 w-full flex-col">
  <!-- header -->
  <div class="flex items-start gap-3 px-6 pb-2 pt-6">
    <mat-icon class="text-amber-500 mt-1" fontSet="material-icons-outlined">warning</mat-icon>
    <div>
      <h2 class="text-xl font-bold">{{ 'DOCUMENT_GENERATE.INVALID_ITEMS_MODAL.TITLE' | t }}</h2>
      <p class="text-secondary mt-1 text-base leading-relaxed">
        <span [innerHTML]="'DOCUMENT_GENERATE.INVALID_ITEMS_MODAL.MESSAGE' | t: { count: data.items.length }"></span>
      </p>
    </div>
  </div>

  <!-- cuerpo -->
  <div class="min-h-0 flex-1 overflow-auto px-6 py-4">
    <div class="overflow-x-auto rounded-xl border">
      <table class="w-full min-w-[420px] border-collapse text-base">
        <thead class="sticky top-0 bg-gray-50 dark:bg-gray-800">
          <tr class="text-secondary text-left">
            <th class="px-4 py-2 font-medium">{{ 'DOCUMENT_GENERATE.COLUMNS.PRODUCT' | t }}</th>
            <th class="px-4 py-2 font-medium">{{ 'DOCUMENT_GENERATE.INVALID_ITEMS_MODAL.COLUMN_PROBLEM' | t }}</th>
          </tr>
        </thead>
        <tbody>
          @for (item of data.items; track item.code) {
          <tr class="border-t">
            <td class="px-4 py-2">
              <div class="flex flex-col">
                <span class="text-secondary text-xs font-semibold">{{ item.code }}</span>
                <span class="uppercase">{{ item.name }}</span>
              </div>
            </td>
            <td class="px-4 py-2">
              <div class="flex flex-wrap gap-1">
                @for (reason of item.reasons; track reason) {
                <span class="rounded-full bg-red-100 px-2 py-0.5 text-xs font-medium text-red-700 dark:bg-red-900/40 dark:text-red-300">
                  {{ reason }}
                </span>
                }
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <!-- footer -->
  <div class="flex justify-end gap-3 border-t bg-gray-50 px-6 py-4 dark:bg-transparent">
    <button mat-stroked-button type="button" (click)="review()">{{ 'DOCUMENT_GENERATE.INVALID_ITEMS_MODAL.REVIEW' | t }}</button>
    <button mat-flat-button color="warn" type="button" (click)="remove()">
      <mat-icon>delete</mat-icon>
      {{ 'DOCUMENT_GENERATE.INVALID_ITEMS_MODAL.REMOVE_ITEMS' | t }}
    </button>
  </div>
</div>
